import { useEffect } from "react";
import * as Option from "fp-ts/lib/Option";
import { config, Env } from "core/utils";
import { doWhenSome } from "core/utils/general";
import { isFuture, isWithin } from "core/utils/date";
import { register, unregister } from "hero/utils/scheduler";
export function useAiring(id, start, end, cb) {
    if (Env.isClient) {
        useTimer("".concat(id, "_START"), start, cb);
        useTimer("".concat(id, "_END"), end, cb);
    }
}
export function useTimer(id, time, cb) {
    useEffect(function () {
        cb();
        if (!isFuture(time))
            return;
        if (!isWithin(config.sessionDurationMs, Date.parse(time)))
            return;
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        doWhenSome(function () { })(register(id, time, function () {
            cb();
        }));
        return function () {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            doWhenSome(function () { })(unregister(id));
        };
    }, [time]);
}
export function useOptTimer(id, optTime, cb) {
    var time = Option.toNullable(optTime);
    useEffect(function () {
        if (time === null)
            return;
        cb();
        if (!isFuture(time))
            return;
        if (!isWithin(config.sessionDurationMs, Date.parse(time)))
            return;
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        doWhenSome(function () { })(register(id, time, function () {
            cb();
        }));
        return function () {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            doWhenSome(function () { })(unregister(id));
        };
    }, [time]);
}
